import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Form,
  Row,
  Button,
  message,
  Tabs,
  Radio,
  Input,
} from "antd";
import { getEvaluateDetail, submitExamExpFeedback } from "./api";
import { judgeIsLogin } from "../../common/utils";
import Logo from "../../assets/images/qingcloud_new.svg";
import "./index.less";

const { TabPane } = Tabs;
const { TextArea } = Input;


const tailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 24 },
};



function ExamExpFeedback() {
  const history = useHistory();
  const urlParams: { id: string, type:string } = useParams();
  const [initData,setInitData]=useState<any>({})
  const userinfo =
    JSON.parse(localStorage.getItem("userinfo") || JSON.stringify({})) || {};
    const [ form ] = Form.useForm();

  const [disabled,setDisabled]=useState(false)
  useEffect(() => {
    if (!userinfo.id) {
      judgeIsLogin();
    }else{
      if(urlParams.type==='view'){
        getEvaluateDetail({
          id:urlParams.id
        }).then((res: any) => {
          if (res && res.code === 0) {
            setInitData(res.data)
            if(urlParams.type==='view'){
              form.setFieldsValue(res.data)
            }
            // message.success(res.msg || '提交成功');
          } else {
            res && message.error(res.msg);
          }
        });
      }
    }
    urlParams.type==='view'?setDisabled(true):setDisabled(false);
    
   
  }, []);

  
 

  const goHome = () => {
    history.push("/");
  };

  const goBack = () => {
    history.go(-1);
  };
 
  const handleFormFinishFailed = (errors: any) => {
    message.error("请完善信息！");
  };

  const handleFormFinish = (values: any) => {
    let params = {
      ...values,
      examID:urlParams.id,
      userID:userinfo.id 
    };
    submitExamExpFeedback(params).then((res: any) => {
      if (res && res.code === 0) {
        message.success(res.msg || '提交成功');
      } else {
        res && message.error(res.msg);
      }
    });
  };

 

  const satisfiedRadioGroup = (data?:any)=>{
    return  (
      (urlParams.type!=='view' || data) && 
      <Radio.Group disabled={disabled} defaultValue={data}>
        <Radio value={1}>很不满意</Radio>
        <Radio value={2}>不满意</Radio>
        <Radio value={3}>一般</Radio>
        <Radio value={4}>比较满意</Radio>
        <Radio value={5}>非常满意</Radio>
      </Radio.Group>
    )
  }

  const difficultyRadioGroup =(data?:any)=>{
    return  (
      (urlParams.type!=='view' || data) && 
      <Radio.Group disabled={disabled} defaultValue={data}>
        <Radio value={1}>很难</Radio>
        <Radio value={2}>难</Radio>
        <Radio value={3}>难度适中</Radio>
        <Radio value={4}>比较简单</Radio>
        <Radio value={5}>非常简单</Radio>
      </Radio.Group>
    )
  }



  return (
    <>
      <div className="exam-before">
        <div className="exam-before-head">
          <div className="head">
            <div className="head-left">
              <div className="logo" onClick={goHome}>
                <img src={Logo} alt="青云" />
                <span className="line">|</span>
                <span className="text">合作伙伴支持平台</span>
              </div>
            </div>
            <div className="head-right">{userinfo.employee_name}</div>
          </div>
        </div>
        <div className="exam-before-content exam-evn-feedback-content">
          <div className="content">
            <div className="detail_basic">
              <Tabs defaultActiveKey="1">
                <TabPane tab="考试体验反馈与建议" key="1">
                  <Row
                    style={{
                      marginTop: 20,
                      marginBottom: 20,
                      height: "100%",
                      overflow: "auto",
                    }}
                  >
                    <Form
                      style={{ width: "100%" }}
                      name="basic"
                      className="exam-exp-feedback-form"
                      onFinish={handleFormFinish}
                      onFinishFailed={handleFormFinishFailed}
                      form = {form}
                    >
                      <Form.Item
                        label="1.您对考试申请、预约流程的评价"
                        name="applyScore"
                        rules={[{ required: true, message: '请选择' }]}
                      >
                          {satisfiedRadioGroup(initData?.applyScore)}
                      </Form.Item>
                      <Form.Item
                        label="2.您对考试实操环境的评价（如操作流程度等方面）"
                        name="environmentScore"
                        rules={[{ required: true, message: '请选择' }]}
                      >
                        {satisfiedRadioGroup(initData?.environmentScore)}
                      </Form.Item>
                      <Form.Item
                        label="3.您对考试期间故障修复速度的评价"
                        name="crashRecoveryScore"
                        rules={[{ required: true, message: '请选择' }]}
                      >
                        {satisfiedRadioGroup(initData?.crashRecoveryScore)}
                      </Form.Item>
                      <Form.Item
                        label="4.您对考试考察项目的评价"
                        name="topicScore"
                        rules={[{ required: true, message: '请选择' }]}
                      >
                        {difficultyRadioGroup(initData?.topicScore)}
                      </Form.Item>
                      <Form.Item
                        label="5.您对上机考试的总体评价"
                        name="wholeScore"
                        rules={[{ required: true, message: '请选择' }]}
                      >
                        {satisfiedRadioGroup(initData?.wholeScore)}
                      </Form.Item>
                      {initData?.remark}
                      <Form.Item
                        label="6.您对上机考试的其他建议或意见"
                        name="remark"
                      >
                       {
                         <TextArea  
                          style={{width:'60%'}}
                          rows={4}
                          disabled={disabled}
                          placeholder="请输入您对上机考试的其他建议或意见" 
                          />
                       }
                      </Form.Item>
                    
                    {
                      urlParams.type!=='view' &&
                      <Form.Item {...tailLayout}>
                        <div className="btn-group" style={{width:"60%"}}>
                          <Button type="primary" htmlType="submit">
                            提交
                          </Button>
                          <Button onClick={goBack}>返回</Button>
                        </div>
                      </Form.Item>
                    }
                      
                    </Form>
                    
                  </Row>
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExamExpFeedback;
